class FetchUtils {
    constructor(baseURL = '') {
        this.baseURL = baseURL;
        this.interceptors = {
            request: [],
            response: []
        };
    }

    // 添加请求拦截器
    addRequestInterceptor(interceptor) {
        this.interceptors.request.push(interceptor);
    }

    // 添加响应拦截器
    addResponseInterceptor(interceptor) {
        this.interceptors.response.push(interceptor);
    }

    // 执行请求拦截器
    async executeRequestInterceptors(config) {
        let result = config;
        for (const interceptor of this.interceptors.request) {
            result = await interceptor(result);
        }
        return result;
    }

    // 执行响应拦截器
    async executeResponseInterceptors(response) {
        let result = response;
        for (const interceptor of this.interceptors.response) {
            result = await interceptor(result);
        }
        return result;
    }

    // 核心请求方法
    async request(url, options = {}) {
        const defaultOptions = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
                //multipart/form-data
            },
            timeout: 300 * 1000,
            credentials: 'same-origin'
        };

        // 合并配置
        const mergedOptions = {
            ...defaultOptions,
            ...options,
            headers: {
                ...defaultOptions.headers,
                ...options.headers
            }
        };

        // 处理请求体
        if (['POST', 'PUT', 'PATCH'].includes(mergedOptions.method) && mergedOptions.body) {
            if (typeof mergedOptions.body === 'object' && mergedOptions.formData) {
                //formData需要删除
                delete mergedOptions.headers['Content-Type'];
            }
            else if (typeof mergedOptions.body === 'object') {
                mergedOptions.body = JSON.stringify(mergedOptions.body);
                mergedOptions.headers['Content-Type'] = 'application/json';
            }
            else if (mergedOptions.str === true) {

                mergedOptions.headers['Content-Type'] = 'application/json';
            }
        }

        // 处理GET请求参数
        if (mergedOptions.method === 'GET' && mergedOptions.params) {
            const queryParams = new URLSearchParams(mergedOptions.params).toString();
            url += (url.includes('?') ? '&' : '?') + queryParams;
        }

        // 执行请求拦截器
        const finalConfig = await this.executeRequestInterceptors({
            url: this.baseURL + url,
            options: mergedOptions
        });

        // 创建超时控制器
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), mergedOptions.timeout);

        try {
            const response = await fetch(finalConfig.url, {
                ...finalConfig.options,
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            // 检查HTTP状态
            if (!response.ok) {
                // 读取响应体中的错误信息
                const errorData = await response.json();
                alert(`HTTP错误! 状态码: ${response.status},错误信息:${errorData.error}`);
                console.error(errorData);
                throw new Error(`HTTP错误! 状态码: ${response.status}`);
            }

            // 处理响应数据
            let data;
            const contentType = response.headers.get('content-type');
            const isDownload = options.download && options.download == 1;
            if (contentType && (contentType.includes('application/json') || contentType.includes('form-data'))) {
                data = await response.json();
            }
            else if (isDownload) {
                data = await response.blob();
            }
            else {
                data = await response.text();
            }

            // 执行响应拦截器
            const finalResponse = await this.executeResponseInterceptors({
                data,
                response,
                status: response.status,
                headers: response.headers
            });

            return finalResponse;
        } catch (error) {

            clearTimeout(timeoutId);


            if (error.name === 'AbortError') {
                throw new Error('请求超时');
            }

            console.error('网络请求错误:', error);

            throw error;
        }
    }

    // 快捷方法
    get(url, params = {}, options = {}) {
        return this.request(url, {
            ...options,
            method: 'GET',
            params
        });
    }

    post(url, data = {}, options = {}) {
        return this.request(url, {
            ...options,
            method: 'POST',
            body: data
        });
    }

    put(url, data = {}, options = {}) {
        return this.request(url, {
            ...options,
            method: 'PUT',
            body: data
        });
    }

    delete(url, options = {}) {
        return this.request(url, {
            ...options,
            method: 'DELETE'
        });
    }
}

// 创建默认实例
const fetchApi = new FetchUtils();

// 添加默认拦截器示例
fetchApi.addRequestInterceptor((config) => {
    // 添加认证token
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.options.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

fetchApi.addResponseInterceptor((response) => {
    //先处理status 不为 200 的情况
    if (response.status !== 200) {
        if (response.status == 400) {
            Promise.reject('input error 404');
        }
        else if (response.status == 401) {
            //TODO 自动 或者  提示 登出
            return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        }
        else if (response.status == 403) {
            Promise.reject('权限错误！');
        }
        else {
            Promise.reject(`network error ${response.status}`);
        }
    }


    //先处理status 为200 ，继续处理
    const { code } = response.data;

    // 继续处理
    if (code == 401) {
        //TODO 自动 或者  提示 登出
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
        // throw new Error(response.data.message || '业务逻辑错误');
    }
    else if (code == 0 || code == 1 || code == 110 || code == 101 || code == 403 || code == 500 || code == 429) {
        //console.log(1212312);
        return Promise.reject(response.data)
    } else {
        //返回标准 code/msg/data字段
        return response.data
    }

});

export default fetchApi;